import { Text, Icon, Stack, Flex } from '@pairy/pds-react';
import cn from 'classnames';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useState } from 'react';

import useCheckUpdatingFile from '@/hooks/useCheckUpdatingFile';

import * as Styled from './index.styles';

const BulkCtaBanner = () => {
  const [imageLoad, setImageLoad] = useState(false);
  const router = useRouter();
  const { fileId } = router.query;

  const { handleDisabledButtonClick } = useCheckUpdatingFile();

  return (
    <Link href={`/user/pdf/share-setting?fileId=${fileId}`}>
      <Styled.Container
        className={cn({
          'background-black': !imageLoad,
        })}
        onClick={(e) => handleDisabledButtonClick(e)}
      >
        <Styled.TextWrapper padding={24}>
          <Stack gap={4} direction="column" width="100%">
            <Text variant="md-semibold" color="zinc_200">
              문의양식에 이메일 인증을 활성화하고,
              <br />
              스팸 응답을 줄여보세요.
            </Text>
            <Text variant="xl-bold" color="white">
              이메일 인증 설정하기
            </Text>
          </Stack>
          <Flex justifyContent="center" alignItems="center" width="fit-content">
            <Icon icon="ph:caret-right" size={24} color="white" />
          </Flex>
        </Styled.TextWrapper>

        <Image
          src="/images/banner/form-banner.png"
          layout="fill"
          objectFit="fill"
          onLoadingComplete={() => setImageLoad(true)}
          unoptimized
        />
      </Styled.Container>
    </Link>
  );
};

export default BulkCtaBanner;
